/* Wish Karo - quick size panel on product cards (mouse + desktop only).
   Hover a card -> sizes for the colour shown on the card -> tap a size to add it to the cart.
   Product data is fetched once per product on first hover (/products/<handle>.js). */
(() => {
  if (window.__wkCardQuick) return;
  window.__wkCardQuick = true;

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)');
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cache = new Map();

  const SIZE_RE = /size|age/i;

  const shortSize = (label) =>
    String(label)
      .replace(/\s*months?\b/i, 'M')
      .replace(/\s*years?\b/i, 'Y')
      .replace(/\s*-\s*/g, '-')
      .trim();

  const fileKey = (src) => {
    if (!src) return '';
    const name = String(src).split('?')[0].split('/').pop() || '';
    return name.replace(/_(\d+x\d*|\d*x\d+)(?=\.)/, '').toLowerCase();
  };

  const handleOf = (card) => {
    const a = card.querySelector('.card__heading a[href*="/products/"]');
    if (!a) return null;
    const m = new URL(a.href, location.origin).pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  };

  const load = (handle) => {
    if (!cache.has(handle)) {
      cache.set(
        handle,
        fetch(`${root}products/${handle}.js`, { headers: { Accept: 'application/json' } }).then((r) => {
          if (!r.ok) throw new Error('product ' + r.status);
          return r.json();
        })
      );
    }
    return cache.get(handle);
  };

  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };

  /* Pick the variant whose photo is the one on the card, so sizes match the colour shown. */
  const baseVariant = (product, card) => {
    const img = card.querySelector('.card__media img');
    const key = img ? fileKey(img.currentSrc || img.src) : '';
    if (key) {
      const hit = product.variants.find((v) => v.featured_image && fileKey(v.featured_image.src) === key);
      if (hit) return hit;
    }
    return product.variants.find((v) => v.available) || product.variants[0];
  };

  const build = (card, product) => {
    const inner = card.querySelector('.card__inner');
    if (!inner || !product || !product.available) return;

    const names = (product.options || []).map((o) => (typeof o === 'string' ? o : o.name));
    let sizeIdx = names.findIndex((n) => SIZE_RE.test(n));
    const single = product.variants.length === 1;
    if (sizeIdx === -1 && !single && names.length === 1) sizeIdx = 0;

    const panel = el('div', 'wk-qs');
    panel.setAttribute('data-wk-qs', '');
    const status = el('p', 'wk-qs__status');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');

    if (single || sizeIdx === -1) {
      const v = baseVariant(product, card);
      const btn = el('button', 'wk-qs__add', 'Add to cart');
      btn.type = 'button';
      btn.dataset.variant = v.id;
      btn.dataset.label = 'Add to cart';
      if (!v.available) {
        btn.disabled = true;
        btn.textContent = 'Sold out';
      }
      panel.append(btn, status);
    } else {
      const base = baseVariant(product, card);
      const seen = new Set();
      const list = product.variants.filter((v) => {
        const same = v.options.every((o, i) => i === sizeIdx || o === base.options[i]);
        if (!same || seen.has(v.options[sizeIdx])) return false;
        seen.add(v.options[sizeIdx]);
        return true;
      });
      if (!list.length) return;

      const head = el('div', 'wk-qs__head');
      head.append(el('p', 'wk-qs__label', 'Choose a size'), el('p', 'wk-qs__hint', 'Tap to add to cart'));

      const sizes = el('div', 'wk-qs__sizes');
      sizes.setAttribute('role', 'group');
      sizes.setAttribute('aria-label', 'Sizes');
      list.forEach((v) => {
        const full = v.options[sizeIdx];
        const b = el('button', 'wk-qs__size', shortSize(full));
        b.type = 'button';
        b.dataset.variant = v.id;
        b.title = full;
        b.setAttribute('aria-label', v.available ? `Add ${full} to cart` : `${full}, sold out`);
        if (!v.available) b.disabled = true;
        sizes.append(b);
      });
      panel.append(head, sizes, status);
    }

    inner.append(panel);
    requestAnimationFrame(() => panel.classList.add('is-ready'));
  };

  const prepare = (card) => {
    if (card.dataset.wkQs) return;
    card.dataset.wkQs = 'loading';
    if (card.querySelector('.card--horizontal')) return;
    const handle = handleOf(card);
    if (!handle) return;
    load(handle)
      .then((p) => {
        card.dataset.wkQs = 'ready';
        build(card, p);
      })
      .catch(() => {
        card.dataset.wkQs = 'error';
      });
  };

  document.addEventListener(
    'pointerover',
    (e) => {
      if (!canHover.matches || e.pointerType === 'touch') return;
      const card = e.target.closest && e.target.closest('.product-card-wrapper');
      if (card) prepare(card);
    },
    { passive: true }
  );

  /* ---------- Add to cart ---------- */
  const refreshBubble = () =>
    fetch(`${root}?section_id=cart-icon-bubble`)
      .then((r) => r.text())
      .then((html) => {
        const bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('.shopify-section') || doc.body;
        bubble.innerHTML = fresh.innerHTML;
      })
      .catch(() => {});

  const add = (panel, trigger) => {
    const id = Number(trigger.dataset.variant);
    if (!id || panel.classList.contains('is-busy')) return;

    const status = panel.querySelector('.wk-qs__status');
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const body = { items: [{ id, quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }

    panel.classList.add('is-busy');
    panel.querySelectorAll('.is-added').forEach((n) => n.classList.remove('is-added'));
    status.textContent = '';
    status.classList.remove('is-error');
    if (trigger.classList.contains('wk-qs__size')) trigger.classList.add('is-adding');
    else {
      trigger.disabled = true;
      trigger.textContent = 'Adding…';
    }

    fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok || data.status) throw new Error(data.description || data.message || 'Could not add this size');

        const item = (data.items && data.items[0]) || data;
        if (cart && typeof cart.renderContents === 'function' && data.sections) {
          if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents({ ...item, sections: data.sections });
        } else {
          refreshBubble();
        }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'wk-card-quick', productVariantId: id, cartData: data });
        }

        panel.classList.add('is-done');
        if (trigger.classList.contains('wk-qs__size')) trigger.classList.add('is-added');
        status.innerHTML = '';
        const msg = el('span', null, trigger.title ? `${trigger.title} added` : 'Added to cart');
        const link = el('a', null, 'View cart');
        link.href = (window.routes && window.routes.cart_url) || `${root}cart`;
        status.append(msg, link);
      })
      .catch((err) => {
        status.classList.add('is-error');
        status.textContent = err.message || 'Could not add this size';
      })
      .finally(() => {
        panel.classList.remove('is-busy');
        trigger.classList.remove('is-adding');
        if (trigger.classList.contains('wk-qs__add')) {
          trigger.disabled = false;
          trigger.textContent = trigger.dataset.label || 'Add to cart';
        }
        clearTimeout(panel._wkT);
        panel._wkT = setTimeout(() => panel.classList.remove('is-done'), 2600);
      });
  };

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest && e.target.closest('.wk-qs__size, .wk-qs__add');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    const panel = trigger.closest('.wk-qs');
    if (panel && !trigger.disabled) add(panel, trigger);
  });

  /* ---------- One frame size for every card photo ----------
     The CSS gives every card a 2:3 frame and fills it (object-fit: cover).
     When a photo has a different shape AND a plain studio background along the edges where the
     gap would be, show the whole photo instead and fill the gap with that background colour,
     so flat product shots never lose their sleeves or hem. */
  const FRAME = 2 / 3;
  const S = 24;

  const edgeColour = (data, wide, first) => {
    let r = 0, g = 0, b = 0;
    const px = [];
    for (let i = 0; i < S; i++) {
      const x = wide ? i : first ? 0 : S - 1;
      const y = wide ? (first ? 0 : S - 1) : i;
      const o = (y * S + x) * 4;
      px.push([data[o], data[o + 1], data[o + 2]]);
      r += data[o];
      g += data[o + 1];
      b += data[o + 2];
    }
    r /= S;
    g /= S;
    b /= S;
    const spread = Math.max(...px.map((p) => Math.abs(p[0] - r) + Math.abs(p[1] - g) + Math.abs(p[2] - b)));
    return spread < 36 ? `rgb(${Math.round(r)}, ${Math.round(g)}, ${Math.round(b)})` : null;
  };

  const fitPhoto = (img) => {
    const w = img.naturalWidth;
    const h = img.naturalHeight;
    if (!w || !h || img.dataset.wkFit) return;
    img.dataset.wkFit = 'cover';
    const ratio = w / h;
    if (Math.abs(ratio - FRAME) < 0.06) return;
    try {
      const canvas = document.createElement('canvas');
      canvas.width = S;
      canvas.height = S;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, S, S);
      const data = ctx.getImageData(0, 0, S, S).data;
      const wide = ratio > FRAME; /* wider photo -> gaps above and below */
      const a = edgeColour(data, wide, true);
      const b = edgeColour(data, wide, false);
      if (!a || !b) return;
      img.dataset.wkFit = 'contain';
      img.classList.add('wk-fit-contain');
      img.style.background = a === b ? a : `linear-gradient(${wide ? 'to bottom' : 'to right'}, ${a} 50%, ${b} 50%)`;
    } catch (e) {
      /* cross-origin photo: keep cover */
    }
  };

  const CARD_IMG = '.product-card-wrapper .card__media img';
  const fitAll = () =>
    document.querySelectorAll(CARD_IMG).forEach((img) => {
      if (img.complete) fitPhoto(img);
    });

  document.addEventListener(
    'load',
    (e) => {
      const t = e.target;
      if (t && t.tagName === 'IMG' && t.matches(CARD_IMG)) fitPhoto(t);
    },
    true
  );

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitAll);
  else fitAll();
  window.addEventListener('load', fitAll);
})();
